module.exports = __webpack_public_path__ + "img/security.cf30c182.svg";